import { http } from "./http"

export const updateQuestionAnswer = async (body: any, id: string) => {
    return (await http.patch(`/user-assessments/question-answer/${id}`, body))
}

export const deleteDependencyFromQuestionAnswer = async (questionAnswerId: string, dependencyId: string) => {
    return (await http.delete(`/user-assessments/question-answer/${questionAnswerId}/dependencies/${dependencyId}`))
}